module.exports = __webpack_public_path__ + "img/sld_four_transformer_dark.b8fd9eb1.svg";